var SENTRY_RELEASE;SENTRY_RELEASE={name: "Foresight Console", version: "1.0.0"};